
import { Link } from 'react-router-dom';
import { Flag } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const NavbarLogo = () => {
  const isMobile = useIsMobile();
  
  return (
    <Link 
      to="/" 
      className="flex items-center gap-2 text-redflags-dark font-medium text-lg"
    >
      <Flag className="w-5 h-5 text-redflags-red" />
      <span className="hidden sm:inline">RedFlags</span>
    </Link>
  );
};

export default NavbarLogo;
